<template>
  <div class="container bg-white" id="hukum">
    <div class="row">
      <div class="col-xs-18">
        <h3>{{ $t('tos.hukum.title') }}</h3>
        <div class="divider"></div>
        <p>{{ $t('tos.hukum.line1') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'definisi',
};
</script>
